import React from "react";
import Spinner from "../../elements/Spinner/Spinner";
import Table from "../../elements/Table/Table";

class TaxList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalVisible: false,
      taxValue: {}
    };
  }

  handleRowClick = info => {
    console.log("VALUE", info);
    const { handleRowClick } = this.props;
    handleRowClick(true, info);
  };

  render() {
    if (!this.props.data) {
      return <Spinner size="lg" fullScreen />;
    }

    console.log("TaxList render", this.props);
    const columns = [
      {
        Header: "Actif/Inactif",
        name: "status",
        accessor: "isActive",
        type: "categoryActive"
      },
      {
        name: "name",
        type: "string",
        accessor: "label"
      },

      {
        name: "taux",
        accessor: "valuePourcent",
        type: "tax"
      },
      {
        name: "mode",
        type: "status",
        maxWidth: 140,
      },
      {
        name: "default",
        accessor: "defaultChecked",
        maxWidth: 90,
        Cell: props =>
          props.value === true ? (
            <i
              className={"fa fa-check"}
              style={{ color: "green", width: "100%" }}
            />
          ) : (
            <span />
          )
      },
      // {
      //   name: "dclVente",
      //   accessor: "codeDeclarationVente",
      //   type: "string",
      //   maxWidth: 140,
      // },
      // {
      //   name: "dclAchat",
      //   accessor: "codeDeclarationAchat",
      //   type: "string",
      //   maxWidth: 140,
      // },
      // {
      //   name: "dclImmo",
      //   accessor: "codeDeclarationImmo",
      //   type: "string",
      //   maxWidth: 140,
      // },
    ];
    var data = this.props.data;
    return (
      <div>
        <Table
          data={data}
          defaultPageSize={10}
          tableName="taxes"
          visibleColumns={columns}
          onRowClick={(id, state, rowInfo) => {
            this.setState({ taxeValue: rowInfo.original });
            this.handleRowClick(rowInfo.original);
          }}
        />
      </div>
    );
  }
}

export default TaxList;
